"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addPersonalSubscription = addPersonalSubscription;
var _fetching = require("@ori/fetching");
var _globalApiClientReact = require("@ori/global-api-client-react");
var _constants = require("../constants");
async function addPersonalSubscription({
  client,
  globalShoppingPersonalSubscriptionDto,
  sessionId,
  tenant,
  placement,
  referer
}) {
  const headers = {
    [_fetching.PLACEMENT]: placement,
    [_constants.REFERER]: referer,
    [_fetching.TENANT_CONTEXT]: tenant
  };
  return (0, _globalApiClientReact.createShoppingSessionPersonalSubscription)(client, sessionId, globalShoppingPersonalSubscriptionDto, headers);
}
